import { post, postExFile, postFile } from "@utils/httpUtil";
// 医生列表-批量导入打标签
export function batchAddLabelByExcel(data, config) {
  return postFile(`/c/pc/community/doctor/v2/batchAddLabelByExcel`, data, config);
}
// 医生列表-下载导入打标签失败
export function importExternalAccountFailDoctorData(data, config) {
  return postExFile(`/c/admin/sp/externalAccount/importExternalAccountFailDoctorData`, data, config);
}
// 医生列表-下载打标签模板
export function downloadImportLabelExcelTemplateFiles(data, config) {
  return post(`/c/pc/community/doctor/downloadImportLabelExcelTemplateFiles`, data, config);
}
// 医生列表-列表
export function doctorGetPageInfo(data, config) {
  return post(`/c/pc/community/doctor/v2/getPageInfo`, data, config);
}
// 上下架, 根据入参状态更新;
export function doctorOnlineByStatus(data, config) {
  return post(`/c/pc/community/doctor/v2/onlineByStatus`, data, config);
}
// 上下架, 根据id删除;
export function doctorDeleteById(data, config) {
  return post(`/c/pc/community/doctor/v2/deleteById`, data, config);
}
// 上下架, 导出数据
export function doctorExportData(data, config) {
  return postExFile(`/c/pc/community/doctor/v2/exportData`, data, config);
}
// 医生详情
export function doctorGetDoctorDetail(data, config) {
  return post(`/c/pc/community/doctor/v2/getDoctorDetail`, data, config);
}
// 医生详情
export function getDoctorServerData(data, config) {
  return post(`/c/pc/community/doctor/v2/getDoctorServerData`, data, config);
}
// 医生详情
export function getWeiboInfo(data, config) {
  return post(`/c/pc/community/doctor/getWeiboInfo`, data, config);
}
// 医生详情
export function configSetting(data, config) {
  return post(`/c/pc/community/doctor/configSetting/get`, data, config);
}
// 医生详情
export function getCommunityHotDoctor(data, config) {
  return post(`/c/pc/community/doctor/communityHotDoctor/get`, data, config);
}
export function configSettingEdit(data, config) {
  return post(`/c/pc/community/doctor/configSetting/edit`, data, config);
}
export function communityHotDoctorEdit(data, config) {
  return post(`/c/pc/community/doctor/communityHotDoctor/edit`, data, config);
}
// 医生列表 - 保存消息推送;
export function saveDoctorMessageCustom(data, config) {
  return post(`/c/pccommunity/message/v2/saveDoctorMessageCustom`, data, config);
}
// 医生列表 - 编辑消息推送;
export function updateDoctorMessageCustom(data, config) {
  return post(`/c/pccommunity/message/v2/updateDoctorMessageCustom`, data, config);
}
export function messageFindDoctorPageMessage(data, config) {
  return post(`/c/pccommunity/message/v2/findDoctorPageMessage`, data, config);
}
// 医生列表 - 查询消息详情 - 列表;
export function findDoctorMessageDetailList(data, config) {
  return post(`/c/pccommunity/message/v2/findDoctorMessageDetailList`, data, config);
}
export function deleteMessage(data, config) {
  return post(`/c/pccommunity/message/v2/deleteMessage`, data, config);
}
export function cancelMessage(data, config) {
  return post(`/c/pccommunity/message/v2/cancelMessage`, data, config);
}
// 医生列表 - 查询消息详情 - 列表;
export function exportDoctorMessageDetailList(data, config) {
  return postExFile(`/c/pccommunity/message/v2/exportDoctorMessageDetailList`, data, config);
}